export default __webpack_public_path__ + "static/media/sd-nv-vertical.63d2e634.svg";